import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import StackTrace from "stacktrace-js"

import { AlertModal } from './alert-modal/AlertModal'

import sendErrorAlert from '../services/ErrorsAlert'

class ErrorBoundry extends Component {

  state = {
    error: false
  }

  componentDidCatch(error, errorInfo) {
    const _error = error ? error.toString() : null
    StackTrace.fromError(error).then(err => {
      if (_error) {
        const values = {
          sessionId: localStorage.sessionId,
          date: new Date(),
          resNumber: localStorage.resNumber,
          url: window.location.pathname,
          errDetails: err.length > 0 && err[0] ? { functionName: err[0].functionName, lineNumber: err[0].lineNumber } : null,
        }
        if (values.sessionId || values.resNumber) {
          // sendErrorAlert(_error, errorInfo, JSON.stringify(values))
        }
      }
    })
    this.setState({ error: true })
  }

  render() {
    const { t } = this.props

    return (
      <React.Fragment>
        {this.state.error ?
          <div>
            <AlertModal
              isOpen={this.state.error}
              title={t('errorTitle')}
              message={t('errorMessage')}
              buttonLabel={t('ok')}
              handleClick={() => this.setState({ error: false }, () => {
                window.location.pathname = '/'
              })}
            />
          </div>
          : this.props.children}
      </React.Fragment>
    )
  }
}

export default withTranslation()(ErrorBoundry);
